import { Badge } from '@givebutter/primitives/badge';
import { faCircleMinus, faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Contact } from 'types/domain';

interface PersonalizedLetterStatusBadgeProps {
    contact: Contact;
}

const PersonalizedLetterStatusBadge = (props: PersonalizedLetterStatusBadgeProps) => {
    const { contact } = props;

    const isRemoved = !!contact.mail_piece?.excluded_at;

    if (!contact.mail_piece?.is_personalized && !isRemoved) {
        return null;
    }

    return (
        <Badge size="sm" color={isRemoved ? 'error' : 'primary'}>
            <FontAwesomeIcon icon={isRemoved ? faCircleMinus : faEdit} />
            {isRemoved ? 'Excluded' : 'Personalized'}
        </Badge>
    );
};

export { PersonalizedLetterStatusBadge };
